import { Component, Input, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

/**
 * Reużywalny formularz kontaktowy.
 * POST-uje cross-origin na Cloud Function (mailer, CORS) → SMTP.
 */
@Component({
  selector: 'app-contact-form',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss',
})
export class ContactFormComponent {
  private http = inject(HttpClient);

  /** Tło pól formularza — landing używa białego, strona kontakt var(--bg). */
  @Input() inputBg = 'var(--bg)';

  readonly sent = signal(false);
  readonly sending = signal(false);
  readonly error = signal<string | null>(null);

  topics = [
    'Pytanie o quiz',
    'Oferta dla DJ-a / prowadzącego',
    'Współpraca',
    'Pomoc techniczna',
    'Coś innego',
  ];

  name = '';
  email = '';
  topic = this.topics[0];
  message = '';
  /** Honeypot — ukryte pole; boty wypełniają, ludzie nie. */
  company = '';

  send() {
    if (this.sending()) return;
    this.error.set(null);

    if (!this.name.trim() || !this.message.trim() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this.email)) {
      this.error.set('Uzupełnij imię, poprawny e-mail i wiadomość.');
      return;
    }

    this.sending.set(true);
    this.http
      .post(environment.mailerUrl, {
        name: this.name,
        email: this.email,
        topic: this.topic,
        message: this.message,
        company: this.company,
      })
      .subscribe({
        next: () => {
          this.sending.set(false);
          this.sent.set(true);
        },
        error: () => {
          this.sending.set(false);
          this.error.set('Nie udało się wysłać. Spróbuj ponownie lub napisz na hej@wesele.live.');
        },
      });
  }

  reset() {
    this.sent.set(false);
    this.error.set(null);
    this.name = '';
    this.email = '';
    this.topic = this.topics[0];
    this.message = '';
    this.company = '';
  }
}
